import React from "react"
import { PronunciationLabel } from "@love-irish/resource-pronunciation-label"

export interface CodexPronunciationProps {
  /** Written pronunciation guide (comma-separated allowed), e.g. "SLAWN-che". */
  pronunciation?: string | null
  /** IPA transcription (raw, no slashes — added at display time), e.g. "sˠl̪ˠaːn̠ʲtʲə". */
  ipaPronunciation?: string | null
  className?: string
}

/**
 * A codex record's pronunciation(s) on ONE condensed line: the written guide and the IPA, each rendered by
 * PronunciationLabel in the "/value/" convention with its own "[?]" cheat-sheet trigger (the written guide
 * opens the pronunciation page; the IPA opens the "Reading IPA (Irish)" guide, keyed off `source`). Shared by
 * the list/card meta and the show page so both read identically. Renders nothing when neither is present.
 */
export const CodexPronunciation: React.FC<CodexPronunciationProps> = ({
  pronunciation,
  ipaPronunciation,
  className,
}) => {
  if (!pronunciation && !ipaPronunciation) return null

  return (
    <div
      className={`flex flex-wrap items-center gap-x-4 gap-y-1 ${className ?? ""}`}
    >
      {pronunciation && (
        <PronunciationLabel pronunciation={pronunciation} source="pronunciation" />
      )}
      {ipaPronunciation && (
        <PronunciationLabel pronunciation={ipaPronunciation} source="ipa" />
      )}
    </div>
  )
}

export default CodexPronunciation
